import { type ProductOffer } from '@/pages/api/[account]/search/offers/ProductOffer'

import { useFetch } from './useFetch'

export const useProductOffers = (productIds: number[]) => {
  return useFetch<ProductOffer[]>(
    ({ account }) => `/api/${account}/search/offers?productIds=${productIds}`,
    { isActive: productIds.length > 0 }
  )
}
